import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { navLinks } from '../mock';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const go = (href) => {
    setOpen(false);
    if (href.startsWith('/')) {
      navigate(href);
      window.scrollTo(0, 0);
      return;
    }
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled ? 'bg-[#0a0a0a]/85 backdrop-blur-md border-b border-white/10 py-3' : 'bg-transparent py-5'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
        <a href="#top" onClick={(e) => { e.preventDefault(); go('#top'); }} className="flex items-center group">
          <img
            src="/sgp-logo-header.png"
            alt="Simply Gold Productions logo"
            width="1222"
            height="629"
            className="h-16 md:h-20 w-auto object-contain"
          />
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {navLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={(e) => { e.preventDefault(); go(l.href); }}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g, '-')}`}
              className="text-sm text-white/70 hover:text-[#c9a85f] font-medium transition-colors relative after:absolute after:left-0 after:-bottom-1 after:h-px after:w-0 after:bg-[#c9a85f] after:transition-all hover:after:w-full"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href="#contact"
          onClick={(e) => { e.preventDefault(); go('#contact'); }}
          className="hidden lg:inline-flex items-center bg-[#c9a85f] hover:bg-[#d8b970] text-black font-display font-semibold text-sm px-6 py-2.5 rounded-md transition-colors tracking-wide"
        >
          Contact
        </a>

        <button className="lg:hidden text-white p-1" onClick={() => setOpen(!open)} aria-label="Toggle menu" aria-expanded={open} aria-controls="mobile-navigation">
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div id="mobile-navigation" className="lg:hidden bg-[#0a0a0a] border-t border-white/10 mt-3">
          <div className="px-6 py-4 flex flex-col gap-4">
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={(e) => { e.preventDefault(); go(l.href); }}
                className="text-left text-white/80 hover:text-[#c9a85f] font-medium py-1"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={(e) => { e.preventDefault(); go('#contact'); }}
              className="bg-[#c9a85f] text-black font-display font-semibold px-6 py-2.5 rounded-md text-center mt-1"
            >
              Contact
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
